import React from 'react';
import { Card, List, Row, Typography } from 'antd';
import { BulbOutlined, PlusOutlined } from '@ant-design/icons';
import Button from "@common/Button";
import EditableSectionDevelopment from "./EditableSectionDevelopment";

const { Title, Text } = Typography;

const ProbingQuestionsCard = ({
    keyProbingQuestions,
    isEditMode,
    editingState,
    adaptedKeys,
    handleEdit,
    handleContentChange,
    handleSave,
    handleCancel,
    handleAddListItem,
    handleRemoveListItem
}) => {
    return (
        <div id="lesson-questions">
            <Title level={2}>Key Probing Questions</Title>
            <Card size="small" icon={<BulbOutlined />}>
                <Row justify="space-between" align="middle" style={{marginBottom: 8}}>
                    <Text strong>Questions</Text>
                    {isEditMode && (
                        <Button
                            type="primary"
                            icon={<PlusOutlined />}
                            size="small"
                            onClick={() => handleAddListItem('keyProbingQuestions', 'New question. Click to edit.', 'Question')}
                        >
                            Add Question
                        </Button>
                    )}
                </Row>
                <List
                    dataSource={keyProbingQuestions || []}
                    renderItem={(item, itemIndex) => (
                        <List.Item key={itemIndex}>
                            {(() => {
                                const contentKey = `keyProbingQuestions.${itemIndex}`;
                                const isEditingThisOne = editingState.key === contentKey;
                                return (
                                    <EditableSectionDevelopment
                                        contentKey={contentKey}
                                        editContent={isEditingThisOne ? editingState.content : item}
                                        isEditing={isEditingThisOne}
                                        isAdapted={adaptedKeys.has(contentKey)}
                                        onEdit={isEditMode ? handleEdit : undefined}
                                        onChange={isEditMode ? handleContentChange : undefined}
                                        onSave={isEditMode ? handleSave : undefined}
                                        onCancel={isEditMode ? handleCancel : undefined}
                                        onDelete={isEditMode ? () => handleRemoveListItem('keyProbingQuestions', itemIndex, item) : undefined}
                                        deleteTooltip="Remove question"
                                    >
                                        <Text>{item}</Text>
                                    </EditableSectionDevelopment>
                                );
                            })()}
                        </List.Item>
                    )}
                />
            </Card>
        </div>
    );
};

export default ProbingQuestionsCard;
